// extracted by mini-css-extract-plugin
module.exports = {"btn":"client-checkout-modal-window_btn__jtz3y"};